<template lang="html">
  <v-toolbar text dense :color="color ? color : 'primary white--text'"  class="text-xs-center">
      <v-toolbar-title style="width: 100%">{{title}}</v-toolbar-title>
      <v-btn v-if="closeCallback" dark icon @click="closeCallback"><v-icon>close</v-icon></v-btn>
  </v-toolbar>
</template>

<script>
export default {
  props: ['title', 'closeCallback', 'color']
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// basic-toolbar.vue?4faaeb96